import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DataName, SensorNodeStatus } from '../../../../util/model';

interface Props {
    index: number;
}

export default function ArrayTable(props: Props) {
    const [antArray1Str, setAntArray1Str] = useState('UNKNOWN');
    const [posArray1Str, setPosArray1Str] = useState('[]');
    const [antArray2Str, setAntArray2Str] = useState('UNKNOWN');
    const [posArray2Str, setPosArray2Str] = useState('[]');
    
    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const SNStatus = layerData.status.SensorNodeStatus;
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < SNStatus.length)) {
            if(SNStatus[props.index].Array.Array.length > 0) {
                setAntArray1Str(SNStatus[props.index].Array.Array[0].AntType);
                setPosArray1Str('[' + SNStatus[props.index].Array.Array[0].Position[0] + ', ' + SNStatus[props.index].Array.Array[0].Position[1] + ', ' + SNStatus[props.index].Array.Array[0].Position[2] + ']');
            } else {
                setAntArray1Str('UNKNOWN');
                setPosArray1Str('[]');
            }
            if(SNStatus[props.index].Array.Array.length > 1) {
                setAntArray2Str(SNStatus[props.index].Array.Array[1].AntType);
                setPosArray2Str('[' + SNStatus[props.index].Array.Array[1].Position[0] + ', ' + SNStatus[props.index].Array.Array[1].Position[1] + ', ' + SNStatus[props.index].Array.Array[1].Position[2] + ']');
            } else {
                setAntArray2Str('UNKNOWN');
                setPosArray2Str('[]');
            }
        } else {
            setAntArray1Str('UNKNOWN');
            setPosArray1Str('[]');
            setAntArray2Str('UNKNOWN');
            setPosArray2Str('[]');
        }
    }, [SNTime, props.index]);
    
    return (
        <div>
            <Table><TableBody>
                <TableRow style={{height:'7px'}}>
                    <TableCell colSpan={3} style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>
                        Antenna Arrays
                    </TableCell>
                </TableRow>
                <TableRow style={{height:'7px'}}>
                    <TableCell style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>
                    </TableCell>
                    <TableCell style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>
                        L1
                    </TableCell>
                    <TableCell style={{paddingTop: 2, paddingBottom: 0, color: 'yellow', fontSize:'12px'}}>
                        L2
                    </TableCell>
                </TableRow>
                <TableRow style={{height:'7px'}}>
                    <TableCell style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>
                        Type
                    </TableCell>
                    <TableCell style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>
                        {antArray1Str}
                    </TableCell>
                    <TableCell style={{paddingTop: 2, paddingBottom: 0, color: 'yellow', fontSize:'12px'}}>
                        {antArray2Str}
                    </TableCell>
                </TableRow>
                    <TableRow style={{height:'7px'}}>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>
                            Position
                        </TableCell>
                    <TableCell style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>
                        {posArray1Str}
                    </TableCell>
                    <TableCell style={{paddingTop: 2, paddingBottom: 0, color: 'yellow', fontSize:'12px'}}>
                        {posArray2Str}
                    </TableCell>
                </TableRow>
            </TableBody></Table>
        </div>
    )
}
